import Bugsnag from '@bugsnag/js';
import { existingPaymentFailure } from './existingPaymentContract';

function attachRetrievalMetadata(event) {
  event.addMetadata('checkout', {
    source: 'embedded/existing-payment-retrieval',
  });
}

const notifyBugsnag = (err, metadata = null) => {
  if (!err) return;
  if (
    err.config?.url
      ?.split('?')[0]
      ?.endsWith('/checkout/retrieve-payment-intent') ||
    err.response?.config?.url
      ?.split('?')[0]
      ?.endsWith('/checkout/retrieve-payment-intent')
  ) {
    Bugsnag.notify(
      new Error(existingPaymentFailure(err)),
      attachRetrievalMetadata
    );
    return;
  }

  const attachMetadata = (event) => {
    if (metadata && typeof metadata === 'object') {
      Object.entries(metadata).forEach(([tab, data]) => {
        event.addMetadata(tab, data);
      });
    }
  };

  if (err instanceof Error) {
    Bugsnag.notify(err, attachMetadata);
    return;
  }

  if (typeof err === 'string') {
    Bugsnag.notify(new Error(err), attachMetadata);
    return;
  }

  const message = err?.data?.message || err?.message || String(err);
  const wrappedError = new Error(message);

  Bugsnag.notify(wrappedError, (event) => {
    if (err && typeof err === 'object') {
      event.addMetadata('apiResponse', {
        status: err.status,
        statusText: err.statusText,
        url: err.config?.url,
        method: err.config?.method,
        errorData: err.data,
      });
    }
    attachMetadata(event);
  });
};

export default notifyBugsnag;
